export const QA_NAME_REQUEST_PROFILE_TAB_EMAILS_SEARCH =
  'requestProfileTabEmailsSearch'

export const REQUEST_PROFILE_TAB_EMAILS_SEARCH_HEIGHT = 32

export const REQUEST_PROFILE_TAB_EMAILS_SEARCH_MAX_LENGTH = 256
